
import { HeroSection } from './components/HeroSection';
import { IntroSection } from './components/IntroSection';
import { BusinessSection } from './components/BusinessSection';
import { EventsSection } from './components/EventsSection';
import { TeamSection } from './components/TeamSection';
import { AchievementsSection } from './components/AchievementsSection';
import { ContactSection } from './components/ContactSection';
import { FooterSection } from './components/FooterSection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <IntroSection />
      <BusinessSection />
      <EventsSection />
      <TeamSection />
      <AchievementsSection />
      <ContactSection />
      <FooterSection />
    </div>
  );
}
